import DotNetObject = DotNet.DotNetObject;
import { PermissionAssetGroup } from '@crimsontide/core/client/interfaces';

export const PermissionAssetGroupService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPermissionAssetGroups: PermissionAssetGroup[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPermissionAssetGroups = async (useCache: boolean = true): Promise<PermissionAssetGroup[]> => {
    if (useCache && cachedPermissionAssetGroups != null)
      return cachedPermissionAssetGroups;

    if (dotNetObj) {
      cachedPermissionAssetGroups = await dotNetObj.invokeMethodAsync<PermissionAssetGroup[]>('GetPermissionAssetGroupsAsync');
      return cachedPermissionAssetGroups;
    } else {
      throw 'PermissionAssetGroupService DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPermissionAssetGroups,
  };
})();
